import {
  RedRed50,
  SequenceMenu,
  useModalState
} from '@sequencehq/core-components'
import { usePermissions } from 'lib/rbac'
import { ArchiveQuoteModal } from 'common/modals/quotes/ArchiveQuote'

export const ArchiveQuoteMenuItem = (props: {
  quoteId: string
  onSuccess?: () => void
  disabled?: boolean
  'data-testid'?: string
}) => {
  const { can } = usePermissions()
  const { isModalOpen, openModal, closeModal } = useModalState()

  if (!can('org.quote:archive')) {
    return null
  }

  return (
    <>
      <SequenceMenu.Item
        uuid="archive-quote"
        label="Archive quote"
        isDisabled={props.disabled}
        style={{ color: RedRed50 }}
        data-testid={props['data-testid']}
        onClick={openModal}
      />
      <ArchiveQuoteModal
        quoteId={props.quoteId}
        isOpen={isModalOpen}
        onClose={closeModal}
        onSuccess={props.onSuccess}
      />
    </>
  )
}
